import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RuleStipModel } from '../../model/rule.model';

@Component({
	selector: 'cv-rule-stip-option-component',
	templateUrl: './rule-stip-option.component.html',
	styleUrls: ['./rule-stip-option.component.scss']
})
export class RuleStipOptionComponent {
	@Input() stip: RuleStipModel;
	@Input() checked: boolean;
	@Input() index: number;
	@Input() disabled: boolean;
	@Output() selected: EventEmitter<RuleStipModel> = new EventEmitter<RuleStipModel>();
	value: any;

	/**
	 * On stip selected emit the event.
	 * @param $event
	 */
	public onValueChange($event: any): void {
		if ($event.target.checked) {
			this.selected.emit(this.stip);
		} else {
			this.selected.emit(null);
		}
	}
}
